import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import Transition from 'react-transition-group/Transition';
import styles from './Snackbar.css';
import { dismissAction } from '../../redux/snackbar';
import { clickOnEnter } from '../../utils/genericHelpers';

const transitionStyles = {
    entering: {
        bottom: '-36px',
    },
    entered: {
        bottom: '20px',
    },
};

const Snackbar = ({ snackbar, dismiss }) => (<Transition
    in={!!snackbar}
    timeout={350}
>
    {state => (<div
        className={styles.container}
        style={transitionStyles[state]}
    >
        {/* Added 'tabIndex' and 'onKeyDown' to make it interactive, and keyboard accessible */}
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        {snackbar ? (<div
            role="alert"
            tabIndex={0}
            aria-label={`${snackbar ? snackbar.message : ''}, Press Enter to dismiss`}
            aria-busy="true"
            aria-live="assertive"
            className={cx(styles.button, {
                [styles.success]: snackbar && snackbar.type === 'success',
                [styles.failure]: snackbar && snackbar.type === 'failure',
            })}
            onClick={dismiss}
            onKeyDown={clickOnEnter}
            key={snackbar.message}
        >
            {snackbar ? snackbar.message : null}
        </div>) : null}
    </div>)}
</Transition>);

Snackbar.propTypes = {
    snackbar: PropTypes.object,
    dismiss: PropTypes.func,
};

export default connect(({ snackbar }) => ({
    snackbar,
}), { dismiss: dismissAction })(Snackbar);



// WEBPACK FOOTER //
// ./src/client/Components/Snackbar/Snackbar.js